import { createSlice } from '@reduxjs/toolkit';
import { resetOnLogout } from '~/reducers/common-actions';
import constants from '~/utils/constants';

const isTaskUpload = ({ type }) => type === constants.taskUpload.TYPE;
const isDriverUpload = ({ type }) => type === constants.driverUpload.TYPE;

export const uploadResultsSlice = createSlice({
    name: 'uploadResults',
    initialState: {},
    reducers: {
        addUploadResult: (state, action) => {
            const { payload } = action;
            const { clientId, status, type } = payload;

            if (!state) {
                state = {};
            }

            if (!state[clientId]) {
                state[clientId] = [];
            }

            if (status !== constants.uploadStatus.ACCEPTED) {
                state[clientId].push(payload);
                return state;
            }

            const newList = state[clientId].filter((message) => {
                return message.type !== type;
            });

            newList.push(payload);
            state[clientId] = newList;
        },
        clearTaskUploadResults: (state, action) => {
            const { payload: clientId } = action;

            if (!state) {
                state = {};
            }

            if (!state[clientId]) {
                state[clientId] = [];
            }

            state[clientId] = state[clientId].filter(
                (result) => !isTaskUpload(result)
            );
        },
        clearDriverUploadResults: (state, action) => {
            const { payload: clientId } = action;

            if (!state) {
                state = {};
            }

            if (!state[clientId]) {
                state[clientId] = [];
            }

            state[clientId] = state[clientId].filter(
                (result) => !isDriverUpload(result)
            );
        },
        resetUploadResults: () => {
            return {};
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetOnLogout, () => {
            return {};
        });
    }
});

export const {
    addUploadResult,
    clearTaskUploadResults,
    clearDriverUploadResults,
    resetUploadResults
} = uploadResultsSlice.actions;

export const selectUploadResults = (state) => {
    return state.uploadResults;
};

export const selectTaskUploadResultsByClientId = (clientId) => (state) => {
    return state.uploadResults[clientId]?.filter(isTaskUpload) || [];
};

export const selectDriverUploadResultsByClientId = (clientId) => (state) => {
    return state.uploadResults[clientId]?.filter(isDriverUpload) || [];
};

export default uploadResultsSlice.reducer;
